import { render, staticRenderFns } from "./MoleculeImageSlider3DTour.vue?vue&type=template&id=285dd8ec&"
import script from "./MoleculeImageSlider3DTour.vue?vue&type=script&lang=js&"
export * from "./MoleculeImageSlider3DTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonSliderAtomImageSliderMatterportSpace: require('/app/components/atoms/common/slider/AtomImageSliderMatterportSpace.vue').default})
